module.exports = __webpack_public_path__ + "img/b_log.c185173c.png";